import { useId } from "react"

// `cellFill` themes the inactive cells for light surfaces (the default
// translucent white only reads on dark backgrounds). When provided, cells
// render without a stroke and the white center dots are omitted — the light
// variant reads cleaner without them.
export function GridMark({ size = 36, cellFill }: { size?: number; cellFill?: string }) {
  const uid = useId()
  const stride = 16
  const cells = [
    { col: 0, row: 0 },
    { col: 1, row: 0 },
    { col: 2, row: 0 },
    { col: 0, row: 1 },
    { col: 1, row: 1 },
    { col: 2, row: 1 },
    { col: 0, row: 2 },
    { col: 1, row: 2 },
    { col: 2, row: 2 },
  ]
  const trackSet = new Set([0, 4, 8])
  const trackCenters = [0, 4, 8].map((i) => ({
    x: cells[i].col * stride + 6,
    y: cells[i].row * stride + 6,
  }))

  return (
    <svg width={size} height={size} viewBox="0 0 44 44" fill="none" aria-hidden="true">
      <polyline
        points={trackCenters.map((p) => `${p.x},${p.y}`).join(" ")}
        stroke="#2E7D4F"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
        opacity="0.35"
      />
      {cells.map((c, i) => {
        const x = c.col * stride
        const y = c.row * stride
        if (trackSet.has(i)) {
          return (
            <g key={i}>
              <defs>
                <linearGradient
                  id={`${uid}lg${i}`}
                  x1={x}
                  y1={y}
                  x2={x + 12}
                  y2={y + 12}
                  gradientUnits="userSpaceOnUse"
                >
                  <stop offset="0%" stopColor="#2E7D4F" />
                  <stop offset="100%" stopColor="#3B9B63" />
                </linearGradient>
              </defs>
              <rect x={x} y={y} width={12} height={12} rx="2" fill={`url(#${uid}lg${i})`} />
            </g>
          )
        }
        return (
          <rect
            key={i}
            x={x}
            y={y}
            width={12}
            height={12}
            rx="2"
            fill={cellFill ?? "rgba(255,255,255,0.08)"}
            stroke={cellFill ? undefined : "rgba(255,255,255,0.05)"}
            strokeWidth={cellFill ? undefined : "0.75"}
          />
        )
      })}
      {!cellFill &&
        trackCenters.map((p, i) => (
          <circle key={i} cx={p.x} cy={p.y} r="1.5" fill="#fff" opacity="0.55" />
        ))}
    </svg>
  )
}
